(() => {
  const STATIONS = {
    standard: new Set(['8080556949768','8080570286344','12302725120264','12302726955272']),
    large: new Set(['8364882919688','12320373702920'])
  };
  const GIFTS = {
    detector: 58894779973896,
    coverStandard: 58964092453128,
    coverLarge: 58964092485896
  };
  const originalFetch = window.fetch.bind(window);
  let syncing = false;
  let scheduled = null;

  const isCartMutation = (input) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    return /\/cart\/(add|change|update|clear)\.js/.test(url);
  };

  const renderCart = (state) => {
    if (!state || !state.sections) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && state.sections['cart-drawer']) {
      try { drawer.renderContents(state); } catch (_) {}
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && state.sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
      const fresh = doc.getElementById('cart-icon-bubble');
      if (fresh) bubble.innerHTML = fresh.innerHTML;
    }
  };

  const request = async (url, body) => {
    const response = await originalFetch(url, {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({
        ...body,
        sections: ['cart-drawer','cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });
    if (!response.ok) throw new Error('Cart gift update failed');
    return response.json();
  };

  const sync = async () => {
    if (syncing) return;
    syncing = true;
    let changed = false;
    let lastState = null;
    try {
      const cart = await originalFetch('/cart.js', {headers:{'Accept':'application/json'}}).then(r => r.json());
      let standardStations = 0;
      let largeStations = 0;

      cart.items.forEach(item => {
        const pid = String(item.product_id);
        if (STATIONS.standard.has(pid)) standardStations += item.quantity;
        if (STATIONS.large.has(pid)) largeStations += item.quantity;
      });

      const totalStations = standardStations + largeStations;
      const desired = new Map([
        [GIFTS.detector, totalStations >= 1 ? 1 : 0],
        [GIFTS.coverStandard, totalStations >= 2 ? standardStations : 0],
        [GIFTS.coverLarge, totalStations >= 2 ? largeStations : 0]
      ]);

      for (const [variantId, qty] of desired) {
        const lines = cart.items.filter(i => Number(i.variant_id) === variantId && i.properties && i.properties._aircomecanik_gift === '1');
        const current = lines.reduce((sum,i) => sum + i.quantity, 0);

        if (lines.length && current !== qty) {
          let remaining = qty;
          for (const line of lines) {
            const target = Math.max(0, Math.min(line.quantity, remaining));
            remaining -= target;
            lastState = await request('/cart/change.js', {id: line.key, quantity: target});
            changed = true;
          }
          if (remaining > 0) {
            lastState = await request('/cart/add.js', {items:[{
              id: variantId,
              quantity: remaining,
              properties:{
                "_aircomecanik_gift":"1",
                "Cadeau AircoMecanik": document.documentElement.lang === 'fr' ? 'Offert avec votre commande' : 'Gratis bij uw bestelling'
              }
            }]});
            changed = true;
          }
        } else if (!lines.length && qty > 0) {
          lastState = await request('/cart/add.js', {items:[{
            id: variantId,
            quantity: qty,
            properties:{
              "_aircomecanik_gift":"1",
              "Cadeau AircoMecanik": document.documentElement.lang === 'fr' ? 'Offert avec votre commande' : 'Gratis bij uw bestelling'
            }
          }]});
          changed = true;
        }
      }

      if (changed) {
        renderCart(lastState);
        document.dispatchEvent(new CustomEvent('aircomecanik:gifts-updated'));
        if (window.location.pathname.endsWith('/cart')) {
          window.location.reload();
        }
      }
    } catch (e) {
      console.warn('AircoMecanik gifts:', e);
    } finally {
      syncing = false;
    }
  };

  const scheduleSync = () => {
    clearTimeout(scheduled);
    scheduled = setTimeout(sync, 180);
  };

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (!syncing && isCartMutation(args[0])) scheduleSync();
    return response;
  };

  document.addEventListener('DOMContentLoaded', scheduleSync);
  window.addEventListener('pageshow', scheduleSync);
  document.addEventListener('change', (e) => {
    if (e.target && (e.target.matches('[name="updates[]"]') || e.target.closest('cart-items,cart-drawer-items'))) scheduleSync();
  });
})();